import { Grid, Typography, Button, Card } from '@mui/material'
import colors from '../../colors'
import { useNavigate } from 'react-router';
import { ReactComponent as Lock } from '../../../icons/lock.svg';
import { ReactComponent as User} from '../../../icons/user.svg';
import { ReactComponent as IconClose } from '../../../icons/closeButton.svg';
import React from 'react'
import {texts} from '../../general/texts'

export const ForgotUserMain = () => {

    const navigate = useNavigate()

  return (
    <Grid container >
        <Grid container item md={10} xs={10} justifyContent={'right'} pt={10} >
          <Button sx={{fontSize:'1.8rem', color:colors.orange, borderRadius:'20px', ':hover': {background:colors.white}}} onClick={() => {navigate('/login')}} ><IconClose /></Button>
        </Grid>
        <Grid container spacing={3} pt={18} >
            <Grid container item md={12} justifyContent={'center'} >
                <Typography sx={{color:colors.darkBlue, fontSize:'2rem', fontFamily:'GerberaBold'}} >{texts["button-forgot-data"]}</Typography>
            </Grid>
            <Grid container item md={12} justifyContent={'center'} >
                <Typography sx={{color:colors.gray, fontSize:"1.3rem", fontFamily:'GerberaMedium'}} >{texts["message-forgot-credential"]}</Typography>
            </Grid>
        </Grid>
        <Grid container item md={12} spacing={5} pt={'10%'} >
            <Grid container item md={6} xs={12} justifyContent={'right'} sx={{'@media (max-width: 899px)' : {justifyContent:'center'}}}  >
                <Card elevation={0} sx={{background:colors.cyan, width:'50%', borderRadius:'20px', '@media (max-width: 899px)' : {width:'90%'}}} >
                    <Button sx={{":hover":{backgroundColor:colors.lightGray}, width:'100%', height:"100%", paddingBottom:'7.2%'}} onClick={()=>{navigate('/resetPassword')}}>
                        <Grid item container md={12} >
                            <Grid item md={3} xs={3} pt={'6%'} >
                                <Lock />
                            </Grid>
                            <Grid item md={9} xs={9} sx={{paddingTop:'10%', pl:'5%'}}>
                                    <Typography sx={{color:colors.darkBlue, fontSize:'1rem', fontFamily:'GerberaLight', textTransform:'none'}} textAlign='left'>{texts["button-forgot-password"]}</Typography>
                            </Grid>
                        </Grid>
                    </Button>
                </Card>
            </Grid>
            <Grid container item md={6} xs={12} justifyContent={'left'} sx={{'@media (max-width: 899px)' : {justifyContent:'center'}}}  >
                <Card elevation={0} sx={{background:colors.cyan,width:'50%', borderRadius:'20px', '@media (max-width: 899px)' : {width:'90%'}}} >
                    <Button sx={{":hover":{backgroundColor:colors.lightGray}, width:'100%', height:"100%", paddingBottom:'7.2%'}} onClick={()=>{navigate('/forgotUser')}}>
                        <Grid item container md={12} xs={12} >
                            <Grid item md={3} xs={3} sx={{pt:'6%'}} >
                                <User />
                            </Grid>
                            <Grid item md={9} xs={9} sx={{paddingTop:'10%', pl:'5%'}}>
                                    <Typography  sx={{color:colors.darkBlue,  fontSize:'1rem', fontFamily:'GerberaLight', textTransform:'none'}}  textAlign='left'>{texts["button-forgot-username"]}</Typography>
                            </Grid>
                        </Grid>
                    </Button>
                </Card>
            </Grid>
        </Grid>
    </Grid>
  )
}
export default ForgotUserMain